
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"35"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"icon-fill",attrs:{"fill":"#355cff","d":"M3 35a3 3 0 01-3-3V14.185a4 4 0 011.35-2.996L12.675 1.172a2 2 0 012.65 0L26.65 11.189A4 4 0 0128 14.185V32a3 3 0 01-3 3z"}})])
          )
        }
      }
    